import React, { useEffect, useState } from "react";
import {
  Table,
  Input,
  Tag,
  Tooltip,
  Popover,
  Button,
  Row,
  Pagination,
  notification,
  Popconfirm,
  message,
} from "antd";
import { useLoading } from "../../context/loadingContext";
import dayjs from "dayjs";
import MerchantInvoiceAdd from "../../components/modal/merchantInvoiceAdd";
import SearchDatePicker from "../../components/search/datePicker";
import SearchPaymentMethod from "../../components/search/searchPaymentMethod";
import GetAdminInvoices from "../../functions/admin/getAdminInvoices";
import SearchAdminByMerchant from "../../components/search/searchAdminByMerchant";
import axios from "axios";
import {
  CodeOutlined,
  DeleteOutlined,
  EditOutlined,
  FilterOutlined,
  LinkOutlined,
  OpenAIFilled,
  RedoOutlined,
} from "@ant-design/icons";
import { useAdmin } from "../../context/adminContext";
import moneyFormat from "../../functions/utils/moneyFormat";
import SearchAdmin from "../../components/search/searchAdmin";
import AdminInvoiceAdd from "../../components/modal/adminInvoiceAdd";
import { bg_button, bg_shadow, bg_text, text_color } from "constant/css";
import TablePagination from "components/pagination/tablePagination";
import AddPos from "components/modal/addPos";
import GetPoses from "functions/admin/getPoses";
import SearchAdminBySubMerchant from "components/search/searchAdminBySubMerchant";
import DeletePos from "functions/admin/deletePos";

const PosList = () => {
  const { showLoading, hideLoading } = useLoading();
  const { searchFields, setSearchFields, showFilter, setShowFilter } =
    useAdmin();
  const [data, setData] = useState([]);

  const [paginationData, setPaginationData] = useState({});
  const [openModal, setOpenModal] = useState(null);
  useEffect(() => {
    prepareQueryStringAndSearch();
  }, [searchFields]);
  const prepareQueryStringAndSearch = () => {
    //object fields length
    const searchFieldsLength = Object.keys(searchFields).length;
    var queryString = "";
    if (searchFieldsLength != 0) {
      queryString = Object.keys(searchFields)
        .map((key) => {
          if (!searchFields[key]) return;
          if (key.includes("At")) {
            // it is date
            return `${key}=${searchFields[key]
              .map((e, i) => {
                if (i == 0)
                  return dayjs(e).startOf("day").format("YYYY-MM-DD HH:MM");
                return dayjs(e).endOf("day").format("YYYY-MM-DD HH:MM");
              })
              .join("->")}`;
          }
          return `${key}=${encodeURIComponent(searchFields[key])}`;
        })
        .join("&");
      fetchPosList(queryString);
    }
  };
  const editPos = (record) => {
    setOpenModal({
      ...record,
      vatMerchantId: record.vatMerchantPos?.[0]?.vatMerchantId || null,
    });
  };
  const deletePos = async (record) => {
    showLoading();
    try {
      const response = await DeletePos(record.id);
      if (response) {
        message.success("POS амжилттай устгагдлаа");
        fetchPosList();
      }
    } catch (error) {
      console.error("Error deleting POS:", error);
      notification.error({
        message: "Устгах алдаа",
        description: "POS устгахад алдаа гарлаа. Дахин оролдоно уу.",
      });
    } finally {
      hideLoading();
    }
  };
  const defaultColumns = [
    {
      title: "#",
      dataIndex: "id",
      key: "id",
      fixed: "left",
      width: 5,
    },
    {
      title: (
        <SearchAdmin
          select={[
            { value: null, title: "Сонго" },
            { value: "DATABANK", title: "Дата банк" },
            { value: "NEGDI", title: "Negdi" },
          ]}
          title="Нийлүүлэгч"
          fieldName="supplier"
        />
      ),
      dataIndex: "supplier",
      key: "supplier",
      width: 45,
      render: (e) => e,
    },
    {
      title: <SearchAdmin title="Загвар" fieldName="mark" />,
      dataIndex: "mark",
      key: "mark",
      align: "right",
      render: (e) => e,
      width: 60,
    },
    {
      title: (
        <SearchAdminBySubMerchant
          title="Дэд мерчант"
          fieldName="vatMerchantId"
        />
      ),
      dataIndex: "vatMerchant",
      key: "vatMerchant",
      align: "middle",
      render: (e) => (
        <Tag color="blue" style={{ margin: "2px" }}>
          {e?.name}
        </Tag>
      ),
      width: 90,
    },
    {
      title: (
        <SearchAdmin
          select={[
            { value: null, title: "Сонго" },
            { value: "ACTIVE", title: "Идэвхтэй" },
            { value: "INACTIVE", title: "Идэвхгүй" },
          ]}
          title="Төлөв"
          fieldName="status"
        />
      ),
      dataIndex: "status",
      key: "status",
      width: 100,
      align: "center",
      render: (e) =>
        e === "ACTIVE" ? (
          <Tag color="cyan">Идэвхтэй</Tag>
        ) : (
          <Tag color="default">Идэвхгүй</Tag>
        ),
    },
    {
      title: (
        <SearchDatePicker
          title="Үүссэн огноо"
          datePicker
          fieldName="createdAt"
        />
      ),
      dataIndex: "createdAt",
      key: "createdAt",
      width: 120,
      render: (e) => (e ? dayjs(e).format("YYYY-MM-DD HH:mm:ss") : "-"),
    },
    {
      title: (
        <SearchDatePicker
          title="Шинэчлэгдсэн огноо"
          datePicker
          fieldName="updatedAt"
        />
      ),
      dataIndex: "updatedAt",
      key: "updatedAt",
      width: 120,
      render: (e) => (e ? dayjs(e).format("YYYY-MM-DD HH:mm:ss") : "-"),
    },
    {
      title: <span style={{ color: "red", fontSize: 10 }}></span>,
      dataIndex: "action",
      key: "action",
      width: 40,
      render: (e, r) => (
        <div className="flex gap-3 justify-center">
          <Button
            className={`${bg_shadow}`}
            onClick={() => editPos(r)}
            icon={<EditOutlined className={`${text_color}`} />}
          ></Button>
          <Popconfirm
            onConfirm={() => deletePos(r)}
            title="Устгахдаа итгэлтэй байна уу?"
            okText="Тийм"
            cancelText="Үгүй"
          >
            <Button
              className={`${bg_shadow}`}
              icon={<DeleteOutlined style={{ color: "red" }} />}
            ></Button>
          </Popconfirm>
        </div>
      ),
    },
  ];

  useEffect(() => {
    refresh();
  }, []);
  const fetchPosList = async (queryString) => {
    showLoading();
    const response = await GetPoses(`&${queryString}`);
    console.log("PosList response", response);
    hideLoading();
    if (response) {
      setData(response.data);
      setPaginationData(response.pagination);
    }
  };

  const addPos = (value) => {
    setOpenModal(true);
  };
  const closeModal = () => {
    setOpenModal(null);
  };

  const refresh = () => {
    setSearchFields({});
    fetchPosList("");
  };
  const toggleFilter = () => {
    setShowFilter(!showFilter);
  };
  return (
    <div className="vatMerchantListontainer mt-3">
      <Row style={{ gap: 10 }}>
        <div className="addButtonMerchant">
          <Button
            type="primary"
            className={`${bg_button} ${bg_shadow} rounded-xl`}
            onClick={addPos}
          >
            Пос нэмэх
          </Button>
        </div>
        <div className="addButtonMerchant">
          <Button
            type="primary"
            className={`${bg_button} ${bg_shadow} rounded-xl`}
            onClick={refresh}
          >
            <RedoOutlined />
          </Button>
        </div>
        <div className="addButtonMerchant">
          <Button
            type={"primary"}
            className={`spayDefaultButton ${bg_button} ${bg_shadow} ${
              !showFilter && "spayDefaultButtonInactive"
            }`}
            onClick={toggleFilter}
          >
            <FilterOutlined />
          </Button>
        </div>
      </Row>
      <div className="tableContainer">
        <Table
          columns={defaultColumns}
          rowKey={(record) => record.id}
          scroll={{
            x: "max-content",
            y: "calc(100vh - 38vh)",
          }}
          size="small"
          pagination={false}
          dataSource={data}
        ></Table>
      </div>
      {openModal && (
        <AddPos
          open={openModal}
          pos={openModal === true ? null : openModal}
          onClose={closeModal}
          refresh={refresh}
        />
      )}
    </div>
  );
};

export default PosList;
